/**
 * Aspexit Logo Component
 *
 * Logo officiel Aspexit - "Precision Agriculture"
 */

interface LogoProps {
  className?: string;
  variant?: 'default' | 'white';
  showTagline?: boolean;
}

export function Logo({ className = '', showTagline = false }: LogoProps) {
  return (
    <svg
      viewBox={showTagline ? "0 0 600 280" : "0 0 600 200"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Aspexit - Precision Agriculture"
    >
      {/* Main text "aspexit" */}
      <text
        x="10"
        y="130"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize="120"
        fontWeight="300"
        fill="#000000"
        letterSpacing="-2"
      >
        aspexit
      </text>

      {/* Green plant/leaf icon on the "i" */}
      <g transform="translate(495, 10)">
        {/* Stem */}
        <rect x="3" y="80" width="4" height="110" fill="#55BC8C" />

        {/* Leaves */}
        <ellipse cx="0" cy="30" rx="12" ry="20" fill="#55BC8C" transform="rotate(-30 0 30)" />
        <ellipse cx="10" cy="50" rx="12" ry="20" fill="#55BC8C" transform="rotate(30 10 50)" />
        <ellipse cx="-2" cy="70" rx="12" ry="20" fill="#55BC8C" transform="rotate(-30 -2 70)" />
      </g>

      {/* Green horizontal line */}
      <line x1="10" y1="195" x2="510" y2="195" stroke="#55BC8C" strokeWidth="8" />

      {/* "Precision Agriculture" tagline */}
      {showTagline && (
        <text
          x="300"
          y="250"
          fontFamily="Georgia, serif"
          fontSize="36"
          fontWeight="300"
          fill="#000000"
          textAnchor="middle"
          letterSpacing="4"
        >
          Precision Agriculture
        </text>
      )}
    </svg>
  );
}

/**
 * Logo Icon (simplified for small sizes)
 */
export function LogoIcon({ className = '', variant = 'default' }: LogoProps) {
  const bgColor = variant === 'white' ? '#FFFFFF' : '#55BC8C';
  const textColor = variant === 'white' ? '#55BC8C' : '#FFFFFF';

  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Aspexit Icon"
    >
      <rect width="40" height="40" rx="8" fill={bgColor} />
      <path
        d="M12 30L20 10L28 30M14 22H26"
        stroke={textColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
